import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import type { FinalSaleReturnState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { memo, useContext, useEffect } from "react";

export const FinalSaleReturnDetails = memo(function FinalSaleReturnDetails({
  state,
  setState,
}: ConditionTypeDetailsProps<FinalSaleReturnState>) {
  const team = useContext(TeamContext);
  useEffect(() => {
    setState({
      ...state,
      validCollections:
        team?.settings?.returns?.finalSaleReturns?.validCollections || [],
      validProductTags:
        team?.settings?.returns?.finalSaleReturns?.validProductTags || [],
    });
    // FIXME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
});
